exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".approveContent-79464{display:flex;flex-direction:column}.approveContent-79464 span{display:block;margin-bottom:6px;font-size:14px;color:rgba(0,0,0,.88)}", ""]);

// Exports
exports.locals = {
	"approveContent": "approveContent-79464"
};